module.exports = __webpack_public_path__ + "media/images/bg-counter-v2-44bda99c74bc71658158067ed0bdf24f.png";